var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.672 20a9.958 9.958 0 004.86-1.258l4.235.353-.353-4.235A9.959 9.959 0 0020.672 10c0-5.523-4.477-10-10-10-5.522 0-10 4.477-10 10s4.478 10 10 10zm4.115-3.138l.277-.166 2.514.21-.21-2.514.167-.277a8 8 0 10-2.747 2.747zm-4.114-1.864a1 1 0 100-2 1 1 0 000 2zm-1-2.998h2v-1c0 .002.004-.003.015-.015.026-.028.088-.097.205-.19.1-.079.131-.1.384-.26A3 3 0 107.672 8h2a1 1 0 111.534.846 4.93 4.93 0 00-.556.383c-.595.471-.978 1.034-.978 1.771v1z",
    fill: "#7C8193"
  })));
}
export default __webpack_public_path__ + "media/images/supportIcon-41c61163.svg";
export { SvgSupportIcon as ReactComponent };